import { render, staticRenderFns } from "./DSTagList.vue?vue&type=template&id=0c634e08&scoped=true&"
import script from "./DSTagList.vue?vue&type=script&lang=ts&"
export * from "./DSTagList.vue?vue&type=script&lang=ts&"
import style0 from "./DSTagList.vue?vue&type=style&index=0&id=0c634e08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c634e08",
  null
  
)

export default component.exports